import cn from 'classnames'

import * as React from 'react'
import { useIntl } from '@/intl'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { DateFieldRange } from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { ParticipantFormType } from '@/scopes/checkout/domain/types/participantFormType'
import { DateInput } from '@/scopes/common/components/FormElements/DateInput'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from '../Form.module.css'

export function BirthdateInput({
  name,
  participantType,
  required,
  dateRange,
}: {
  name: string
  participantType: ParticipantFormType
  required?: boolean
  dateRange?: DateFieldRange
}) {
  const intl = useIntl()
  const dateFormat = useConfiguration('dateFormat')
  useTrackFieldValidation(name)

  const validateErrorMessageId = participantType === ParticipantFormType.MainBooker
    ? 'checkout_steps_participants_form_field_validate_error_message_mainbooker_birthdate'
    : 'checkout_steps_participants_form_field_validate_error_message_generic_birthdate'

  return (
    <DateInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_birthdate' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({
        id: 'checkout_steps_participants_form_field_required_error_message_birthdate',
      })}
      patternErrorMessage={intl.formatMessage({
        id: 'checkout_steps_participants_form_field_pattern_error_message_birthdate',
      })}
      validateErrorMessage={intl.formatMessage({ id: validateErrorMessageId })}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldS)}
      dateRange={dateRange}
      dateFormat={dateFormat}
    />
  )
}
